import React, { forwardRef, useImperativeHandle, useState } from "react";
import { handleNonIntegerInputs } from "components/Pages/Dashboard/ActivateCard/utils";
import { Text, Input, InputContainer } from "components/common";
import { isKey } from "utils";

const BankInfoForm = forwardRef(
  (
    {
      routingNumber,
      setRoutingNumber,
      accountNumber,
      setAccountNumber,
      confirmAccountNumber,
      setConfirmAccountNumber,
      required = false,
    },
    ref,
  ) => {
    const [shouldShowAccountPass, setShouldShowAccountPass] = useState(false);
    const [shouldShowConfirmAccountPass, setShouldShowConfirmAccountPass] =
      useState(false);

    const [routingNumberError, setRoutingNumberError] = useState("");
    const [accountNumberError, setAccountNumberError] = useState("");
    const [confirmAccountNumberError, setConfirmAccountNumberError] =
      useState("");

    useImperativeHandle(ref, () => ({
      resetFields() {
        setRoutingNumber("");
        setAccountNumber("");
        setConfirmAccountNumber("");
        setRoutingNumberError("");
        setAccountNumberError("");
        setConfirmAccountNumberError("");
      },
      resetFieldErrors() {
        setRoutingNumberError("");
        setAccountNumberError("");
        setConfirmAccountNumberError("");
      },
      validateFields() {
        let isValid = true;
        if (!routingNumber) {
          setRoutingNumberError("Routing number must not be empty.");
          isValid = false;
        }

        if (!accountNumber) {
          setAccountNumberError("Account number must not be empty.");
          isValid = false;
        }

        if (!confirmAccountNumber) {
          setConfirmAccountNumberError("Account number must not be empty.");
          isValid = false;
        }

        if (accountNumber !== confirmAccountNumber) {
          setConfirmAccountNumberError("Account numbers must match.");
          isValid = false;
        }

        return isValid;
      },
    }));

    const required_label = required ? "*" : "";

    return (
      <>
        <Text className="text-base mt-3 mb-1">
          Routing Number
          {required_label}
        </Text>
        <Text className="mt-3 mb-1 text-small text-red-600">
          {routingNumberError}
        </Text>
        <InputContainer className="bg-white"error={routingNumberError}>
          <Input
            alt="routing-number"
            value={routingNumber || ""}
            onKeyDown={(e) => handleNonIntegerInputs(e, isKey)}
            onChange={(e) => {
              if (e.target.value.length <= 9) {
                setRoutingNumber(e.target.value);
              }
            }}
            placeholder="xxxxxxxxxx"
            type="number"
            pattern="[0-9]*"

          />
        </InputContainer>
        <Text className="text-base mt-3 mb-1">
          Account Number
          {required_label}
        </Text>
        <Text className="mt-3 mb-1 text-small text-red-600">
          {accountNumberError}
        </Text>
        <InputContainer className="bg-white" error={accountNumberError}>
          <Input
            alt="account-number"
            value={accountNumber || ""}
            onKeyDown={(e) => handleNonIntegerInputs(e, isKey)}
            onChange={(e) => {
              if (e.target.value.length <= 17) {
                setAccountNumber(e.target.value);
              }
            }}
            type={shouldShowAccountPass ? "number" : "password"}
            placeholder="xxxxxxxxxx"
            pattern="[0-9]*"
          />
          <i
            onClick={() => setShouldShowAccountPass(!shouldShowAccountPass)}
            role="button"
            className={`fas my-auto ${
              shouldShowAccountPass ? "fa-eye" : "fa-eye-slash"
            }`}
          />
        </InputContainer>
        <Text className="text-base mt-3 mb-1">
          Confirm Account Number
          {required_label}
        </Text>
        <Text className="mt-3 mb-1 text-small text-red-600">
          {confirmAccountNumberError}
        </Text>
        <InputContainer className="bg-white" error={confirmAccountNumberError}>
          <Input
            alt="confirm-account-number"
            value={confirmAccountNumber || ""}
            onKeyDown={(e) => handleNonIntegerInputs(e, isKey)}
            onChange={(e) => {
              if (e.target.value.length <= 17) {
                setConfirmAccountNumber(e.target.value);
              }
            }}
            type={shouldShowConfirmAccountPass ? "number" : "password"}
            placeholder="xxxxxxxxxx"
            pattern="[0-9]*"

          />
          <i
            onClick={() =>
              setShouldShowConfirmAccountPass(!shouldShowConfirmAccountPass)
            }
            role="button"
            className={`fas my-auto ${
              shouldShowConfirmAccountPass ? "fa-eye" : "fa-eye-slash"
            }`}
          />
        </InputContainer>
      </>
    );
  },
);

export default BankInfoForm;
